// extracted by mini-css-extract-plugin
export var chevron = "_c2-4";
export var chevronExpanded = "_c2-5";
export var row = "_c2-0";
export var rowBody = "_c2-6";
export var rowDescription = "_c2-7";
export var rowHeader = "_c2-1";
export var rowTitle = "_c2-2";
export var rowTitleComplete = "_c2-3";